import HttpClient from '@/api/http-client';

export interface CustomerInfo {
    id: number;
    domain: string;
}

interface UserInfoApi {
    username: string;
    current_domain: string;
    user_settings: {
        customers: Array<CustomerInfo>;
    };
    users?: {
        [extension: string]: string;
    };
}

export default class UserInfo {
    username: string;

    currentDomain: string;

    customers: Array<CustomerInfo>;

    users: {[extension: string]: string} = {};

    constructor(
        username: string,
        currentDomain: string,
        customers: Array<CustomerInfo>,
        users: {[extension: string]: string} = {},
    ) {
        this.username = username;
        this.currentDomain = currentDomain;
        this.customers = customers;
        this.users = users;
    }

    getUserNameByExtension(extension: string): string | null {
        return this.users[extension] || null;
    }

    static fromInit(): UserInfo {
        return new UserInfo('NaN', '', []);
    }

    static async fromApi(http: HttpClient): Promise<UserInfo> {
        const options = {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
        };

        const response = await http.get('/userinfo', {}, options);

        const data = response.data as UserInfoApi;

        return new UserInfo(
            data.username,
            data.current_domain,
            data.user_settings.customers,
            data.users || {},
        );
    }
}
